import React, {Component, createRef} from 'react'
import PropsTypes from 'prop-types'
import Clipboard from "clipboard";
import {_deleteAccount, _requestLoginAccount} from "../../../../services/apis/AccountServices";
import {Badge} from "reactstrap";

const badgeColorMap = {
    active: 'success',
    inactive: 'warning'
}

class AccountRecord extends Component {
    _passButton = createRef()
    _rePassButton = createRef()

    state = {
        loadingLogin: false
    }

    componentDidMount() {
        this._initClipboard()
    }

    componentWillUnmount() {
        this._destroyClipboard()
    }

    _destroyClipboard = () => {
        if (this._clipboard) {
            this._clipboard.destroy()
        }
    }

    _initClipboard = () => {
        if (this.initClipboard) return

        if (this._passButton.current) {
            this.initClipboard = true
            this._clipboard = new Clipboard(this._passButton.current)
        }

        if (this._rePassButton.current) {
            this.initClipboard = true
            this._clipboard = new Clipboard(this._rePassButton.current)
        }
    }

    _requestLogin = () => {
        this.setState({loadingLogin: true})

        const {device, record} = this.props

        _requestLoginAccount(record._id, device)
            .then(response => {
                this.setState({loadingLogin: false})
            })
            .catch(error => {
                this.setState({loadingLogin: false})
            })
    }

    _deleteAccount = () => {
        const {_id} = this.props.record
        this.props.removeAccountFormState(_id)

        _deleteAccount(_id)
            .then(result => {
                if (result.success) {
                    this.props.onRefreshPage()
                }
            })
    }

    _handleClickLogin = (e) => {
        e.preventDefault()

        this._requestLogin()
    }

    _handleClickEdit = () => {
        this.props.onChangeModalData(this.props.record)
        this.props.onToggleModal()
    }

    render() {
        const {order, record} = this.props
        const {email, password, recoverEmail, recoverPhone, proxy, status, note, _id} = record
        const {loadingLogin} = this.state

        return (
            <div className='WorkerRecord' id={`W-${_id}`}>
                <div className='row table-row'>
                    <div className="Order col">{order}</div>
                    <div className='Email col'>{email}</div>
                    <div className='Password col'>
                        <button ref={this._passButton} className='btn btn-primary' data-clipboard-text={password}>
                            Copy
                        </button>
                    </div>
                    <div className='Phone col'>
                        {recoverPhone}
                    </div>
                    <div className='RecoverEmail col'>{recoverEmail}</div>
                    {/*<div className='RecoverPassword col'>*/}
                    {/*    <button ref={this._rePassButton} className='btn btn-primary'*/}
                    {/*            data-clipboard-text={recoverPassword}>*/}
                    {/*        Copy*/}
                    {/*    </button>*/}
                    {/*</div>*/}
                    <div className="Note col">
                        {note}
                    </div>
                    <div className='Proxy col'>{proxy}</div>
                    <div className='Status col'><Badge color={badgeColorMap[status]} pill>{status}</Badge></div>
                    <div className='Actions col'>
                        <div className="Actions d-flex flex-row">
                            <div className="Action">
                                <button className='btn btn-success' disabled={loadingLogin}
                                        onClick={this._handleClickLogin}>
                                    <i className="fas fa-sign-in-alt"/>
                                </button>
                            </div>

                            <div className="Action">
                                <button className='btn btn-primary' onClick={this._handleClickEdit}>
                                    Edit
                                </button>
                            </div>

                            <div className="Action">
                                <button className='btn btn-danger' onClick={this._deleteAccount}>
                                    <i className="fas fa-times"/>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

AccountRecord.propsTypes = {
    onChangeModalData: PropsTypes.func.isRequired,
    onToggleModal: PropsTypes.func.isRequired,
    removeAccountFormState: PropsTypes.func.isRequired,
    onRefreshPage: PropsTypes.func.isRequired,
    record: PropsTypes.object.isRequired,
    device: PropsTypes.string.isRequired,
    order: PropsTypes.number.isRequired
}

export default AccountRecord



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/accounts/AccountRecord.js